<template lang="pug">
  dv-form(
    v-model="formData"
    :schema="schema"
    :nestable="false"
    v-slot="{ fields }"
  )
    v-row
      v-col(cols="12")
        dv-form-field(
          :field="fields.options"
        )
</template>

<script>
import DvForm from '@/packages/ui/components/forms/DvForm.vue';
import DvFormField from '@/packages/ui/components/forms/DvFormField.vue';
import TextInputOptionField from '../inputs/TextInputOptionField.vue';

import OptionsList from '../lists/OptionsList.vue';

export default {
  components: {
    DvForm,
    DvFormField,
    OptionsList,
  },
  props: {
    value: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      formData: {
        options: this.value,
      },
    };
  },
  computed: {
    schema() {
      return [
        {
          name: 'options',
          value: 'options',
          component: OptionsList,
          props: {
            component: TextInputOptionField,
            props: {
              withScore: true,
            },
            defaultOptionsLength: 1,
          },
        },
      ];
    },
  },
  watch: {
    value: {
      handler(val) {
        this.formData.options = val;
      },
      immediate: true,
    },
    'formData.options': {
      handler(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
